export default __webpack_public_path__ + "static/media/info-journey-en.70815620.gif";